import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminDrugClasses;
export const adminDrugClassesSelector = (state: RootState) => getState(state).data;
export const adminDrugClassesIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const adminDrugClassesIsReadySelector = (state: RootState) => getState(state).isReady;
export const adminDrugClassesErrorSelector = (state: RootState) => getState(state).error;
